module.exports = __webpack_public_path__ + "img/215.d5e61e45.jpg";